import './reset.scss';

import React from 'react';
import { createRoot } from 'react-dom/client';

import { KcPage } from './kc.gen';

declare global {
  interface Window {
    kcContext?: any;
  }
}

const root = document.getElementById('root');
if (!root) throw new Error('No #root element');

const app: React.ReactNode = (
  <React.StrictMode>
    {!window.kcContext ? <h1>No Keycloak Context</h1> : <KcPage kcContext={window.kcContext} />}
  </React.StrictMode>
);

createRoot(root).render(app);
